import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale, useLocalizedPath } from '../hooks/useLocale';

export interface RelatedLink {
  label: string;
  href: string;
}

interface RelatedLinksProps {
  links: RelatedLink[];
}

export const RelatedLinks: React.FC<RelatedLinksProps> = ({ links }) => {
  const locale = useLocale();
  const localizedPath = useLocalizedPath();

  return (
    <section className="py-12 border-t border-gray-200 dark:border-gray-700">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
        {locale === 'zh' ? '相关链接' : 'Related Links'}
      </h2>
      <div className="flex flex-wrap gap-4">
        {links.map((link) => (
          <Link
            key={link.href}
            to={localizedPath(link.href)}
            className="text-primary-600 dark:text-primary-400 hover:underline"
          >
            {link.label}
          </Link>
        ))}
      </div>
    </section>
  );
};
